import React from "react";
import BaseModal from "@components/common/HPBaseModal";
import { WarningIcon } from "@assets/images";
import { ModalProps } from "@_constants/modal";
import { t } from "@utils/i18n";

interface NoAvailableSurveysModalProps extends ModalProps {
  surveyCount: number;
  action: () => void;
}

const NoAvailableSurveysModal: React.FC<NoAvailableSurveysModalProps> = ({
  action,
  surveyCount,
}) => {
  return (
    <BaseModal
      title={t("modals.noAvailableSurveysToAdd.title")}
      onCancel={action}
      cancelButtonText="Close"
      headerIcon={<WarningIcon />}
      message={t("modals.noAvailableSurveysToAdd.message", {
        count: surveyCount,
      })}
    />
  );
};

export default NoAvailableSurveysModal;
